import { defineMessages } from 'react-intl';

export default defineMessages({
    matchedName: {
        id: 'ml.quoteandbind.common.employeraffilitationsaccordion.matchedName',
        defaultMessage: 'MATCHED NAME'
    },
    matchingResults: {
        id: 'ml.quoteandbind.common.employeraffilitationsaccordion.matchingResults',
        defaultMessage: 'MATCHING RESULTS'
    },
    companyName: {
        id: 'ml.quoteandbind.common.employeraffilitationsaccordion.companyName',
        defaultMessage: 'COMPANY NAME'
    },
    gpc: {
        id: 'ml.quoteandbind.common.employeraffilitationsaccordion.gpc',
        defaultMessage: 'GPC'
    },
    accountType: {
        id: 'ml.quoteandbind.common.employeraffilitationsaccordion.accountType',
        defaultMessage: 'Account Type'
    },
    preferredEmployer: {
        id: 'ml.quoteandbind.common.employeraffilitationsaccordion.preferredEmployer',
        defaultMessage: 'Preferred Employer'
    },
    waitingPeriod: {
        id: 'ml.quoteandbind.common.employeraffilitationsaccordion.waitingPeriod',
        defaultMessage: 'WAITING PERIOD IS FIRST OF THE MONTH FOLLOWING 60 DAYS.'
    }
});
